export default __webpack_public_path__ + "static/media/topic900_bg1.9d586758.png";